const moment = require('moment')
require('moment/locale/pt-br')

export const handleColor = (moved_at, stageId, statusId = null, idleRules = []) => {
	if (!moved_at) return ''

	let minutes = moment().diff(moved_at, 'minutes')
	let primaryRules = []

	const filterBy = (id, prop = 'funnel_stage_status_id') =>
		idleRules.filter((idle) => idle[prop] === id)
			.filter((i) => i.time_start <= minutes && i.time_end >= minutes)
			.sort((a, b) => moment(a.created_at).format('YYYYMMDD') - moment(b.created_at).format('YYYYMMDD'))

	if (statusId) {
		primaryRules = filterBy(statusId)
		if (primaryRules.length === 0 && stageId)
			/** Pega apenas regras de ociosidade que não estão vinculadas a um status */
			primaryRules = filterBy(stageId, 'funnel_stage_id').filter(rule => !rule.funnel_stage_status_id)

	} else if (stageId) {
		primaryRules = filterBy(stageId, 'funnel_stage_id').filter(rule => !rule.funnel_stage_status_id)
	}

	if (primaryRules.length) return [...primaryRules].pop().color
	else return '#868fa0'
}
